import { Pipe, PipeTransform } from '@angular/core';
import { Stations } from 'src/app/services/stations/stations';

@Pipe({
  name: 'filterStatus'
})
export class FilterStatusPipe implements PipeTransform {

  transform(items: Stations[], searchText: string): any[] {
    // console.log(items)
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => it.bestStatus.toLowerCase().includes(searchText));
}

}
